import { GzAntimalwareAntiTamperingWebComponent } from './component/GzAntimalwareAntiTamperingWebComponent';

export { GzAntimalwareAntiTamperingWebComponent };
